module.exports = __webpack_public_path__ + "static/media/300x250.899a520d.png";